import { Grid, IconButton, InputAdornment } from "@mui/material";
import AppDialog from "../../../components/Common/AppDialog";
import ImportantNotice from "../../../components/Common/ImportantNotice";
import CustomTextField from "../../../components/Form/CustomTextField";
import { useEffect, useState } from "react";
import CustomSelect from "../../../components/Form/CustomSelect";
import { Icon } from "@iconify/react/dist/iconify.js";

export default function AddUser(props) {
  const [formValues, setFormValues] = useState();
  const [showPw, setShowPw] = useState(false);
  const [showConfirmPw, setConfirmShowPw] = useState(false);

  useEffect(() => {
    if (!props?.open) {
      setFormValues({});
    } else if (props?.type === 'edit' && props?.userDetails) {
      setFormValues({
        name: props?.userDetails?.name || '',
        role_id: props?.userDetails?.role || '',
        role_name: props?.userType === 'admin' ? 'Admin' : props?.userDetails?.role_name || props?.userDetails?.role || '',
        department_id: props?.userDetails?.department_id || '',
        phone: props?.userDetails?.phone?.startsWith('60') ? props.userDetails.phone.slice(2) || '' : props.userDetails.phone || '',
        email: props?.userDetails?.email || '',
      })
    } else if (props?.type === 'add') {
      setFormValues({
        role_id: props?.userType === 'admin' ? 'Admin' : '',
      });
    }
  }, [props?.userDetails, props?.type, props?.open])

  const handleValueChange = (field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = () => {
    // check if formValues.phone starts with 60, if not add 60 at the start
    if (!formValues?.phone?.startsWith('60') && formValues?.phone) {
      formValues.phone = `60${formValues.phone}`;
    }
    let payload = {
      name: formValues?.name || '',
      email: formValues?.email || '',
      phone: `${formValues?.phone || ''}`,
    }
    if (props?.userType === 'admin') {
      payload.password = formValues?.password || '';
      payload.password_confirmation = formValues?.confirm_password || '';
    } else {
      payload.member_group_id = formValues?.role_id || '1';
      payload.department_id = formValues?.department_id || '';
    }
    props?.submit(payload)
  }

  return (
    <>
      <AppDialog
        open={props.open}
        close={() => props.close()}
        title={`${props?.type === 'edit' ? 'Edit' : 'Add'} User`}
        positiveTitle={"Save"}
        positivePress={() => handleSubmit()}
        cancelButton={true}
        width={'50%'}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CustomTextField
              title={'Name'}
              values={formValues?.name || ''}
              onChange={(e) => handleValueChange('name', e)}
              placeholder={'Name'}
              error={props?.error?.name}
            />
          </Grid>
          <Grid item xs={12}>
            {
              // props?.userType === 'admin' ?
              <CustomTextField
                title={'Role'}
                values={formValues?.role_name || ''}
                onChange={(e) => handleValueChange('role_name', e)}
                disabled={true}
                error={props?.error?.role_name}
              />
              // :
              // <CustomSelect
              //   title={'Role'}
              //   values={formValues?.role_id || ''}
              //   onChange={(e) => handleValueChange('role_id', e)}
              //   data={props?.roleList || []}
              //   labelName={'name'}
              //   valueName={'id'}
              //   error={props?.error?.role_id}
              //   disabled={true}
              // />
            }
          </Grid>
          {
            props?.userType !== 'admin' &&
            <Grid item xs={12}>
              <CustomSelect
                title={'Department'}
                values={formValues?.department_id || '-1'}
                onChange={(e) => handleValueChange('department_id', e)}
                data={props?.departmentList || []}
                labelName={'name'}
                valueName={'id'}
                placeholder={'Department'}
                error={props?.error?.department_id}
              />
            </Grid>
          }
          <Grid item xs={12}>
            <CustomTextField
              title={'Phone Number'}
              values={formValues?.phone || ''}
              onChange={(e) => handleValueChange('phone', e)}
              type={'number'}
              placeholder={`Your phone number`}
              error={props?.error?.phone}
              InputProps={{
                startAdornment: <InputAdornment position="start"><div style={{ borderRight: '1px solid #E6E6E6', paddingRight: 10, color: '#101010' }}>+60</div></InputAdornment>,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              title={'Email'}
              values={formValues?.email || ''}
              onChange={(e) => handleValueChange('email', e)}
              placeholder={'Email'}
              error={props?.error?.email}
            />
          </Grid>
          {
            props?.userType === 'admin' &&
            <>
              <Grid item xs={12}>
                <CustomTextField
                  placeholder='Enter your password'
                  typePw={showPw ? 'text' : 'password'}
                  title={"Password"}
                  error={props?.error?.password}
                  values={formValues?.password}
                  variant="standard"
                  style={{ backgroundColor: 'white' }}
                  onChange={(e) => handleValueChange('password', e)}
                  InputProps={{
                    endAdornment: <IconButton
                      aria-label="toggle password visibility"
                      onClick={(e) => setShowPw(!showPw)}
                      edge="end"
                    >
                      {showPw ? <Icon icon="ri:eye-line" width="24" height="24" /> : <Icon icon="ri:eye-close-line" width="24" height="24" />}
                    </IconButton>,
                    // startAdornment: <Icon icon="fluent:lock-closed-32-regular" className="me-2 text-muted" width="24" height="24"></Icon>,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomTextField
                  placeholder='Confirm your password'
                  typePw={showConfirmPw ? 'text' : 'password'}
                  title={"Confirm Password"}
                  error={props?.error?.confirm_password}
                  values={formValues?.confirm_password}
                  variant="standard"
                  style={{ backgroundColor: 'white' }}
                  onChange={(e) => handleValueChange('confirm_password', e)}
                  InputProps={{
                    endAdornment: <IconButton
                      aria-label="toggle password visibility"
                      onClick={(e) => setConfirmShowPw(!showConfirmPw)}
                      edge="end"
                    >
                      {showConfirmPw ? <Icon icon="ri:eye-line" width="24" height="24" /> : <Icon icon="ri:eye-close-line" width="24" height="24" />}
                    </IconButton>,
                    // startAdornment: <Icon icon="fluent:lock-closed-32-regular" className="me-2 text-muted" width="24" height="24"></Icon>,
                  }}
                />
              </Grid>
            </>
          }
        </Grid>
      </AppDialog>
    </>


  );
}